module.exports = __webpack_public_path__ + "static/media/rainy2.01525709.jpg";